export const policyholderTypes = [
  { id: 1, key: 'natural', value: 'Фізична особа' },
  { id: 2, key: 'legal', value: 'Юридична особа' },
  { id: 3, key: 'beneficiary', value: 'Пільговик' },
];

export const policyholderTypeIds = policyholderTypes.reduce((acc, type) => {
  acc[type.key.toUpperCase()] = type.id;
  return acc;
}, Object.create(null));
